import { FC } from 'react';

interface IFingerIconProps {
  stroke?: string;
}

const FingerIcon: FC<IFingerIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill={stroke ?? 'none'}
    >
      <path
        d="M5.16732 14.6663H3.16732C2.8137 14.6663 2.47456 14.5259 2.22451 14.2758C1.97446 14.0258 1.83398 13.6866 1.83398 13.333V8.66634C1.83398 8.31272 1.97446 7.97358 2.22451 7.72353C2.47456 7.47348 2.8137 7.33301 3.16732 7.33301H5.16732M9.83398 5.99967V3.33301C9.83398 2.80257 9.62327 2.29387 9.2482 1.91879C8.87313 1.54372 8.36442 1.33301 7.83398 1.33301L5.16732 7.33301V14.6663H12.6873C13.0089 14.67 13.3209 14.5573 13.5659 14.349C13.8109 14.1407 13.9724 13.8509 14.0207 13.533L14.9407 7.53301C14.9697 7.34191 14.9568 7.1468 14.9029 6.96118C14.849 6.77556 14.7554 6.60387 14.6286 6.45802C14.5017 6.31216 14.3447 6.19563 14.1684 6.11649C13.992 6.03734 13.8006 5.99749 13.6073 5.99967H9.83398Z"
        stroke={stroke ?? '#98A2B3'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FingerIcon;
